var render, staticRenderFns
import script from "./PaymentMethod.vue?vue&type=script&lang=js"
export * from "./PaymentMethod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d85938c')) {
      api.createRecord('8d85938c', component.options)
    } else {
      api.reload('8d85938c', component.options)
    }
    
  }
}
component.options.__file = "src/components/mixins/PaymentMethod.vue"
export default component.exports